import useSportEntitySubscriptions from '@hooks/useSportEntitySubscriptions'

const FollowMyTeamMyTeams = () => {
  const { data: sportEntitySubscriptions } = useSportEntitySubscriptions({
    entityType: 'competitor',
  })

  return (
    <div>
      List of My Followed Teams{' '}
      {sportEntitySubscriptions?.map((entity) => (
        <div key={entity.entityId}>
          {entity.entityId} {entity.title}
        </div>
      ))}
    </div>
  )
}

export default FollowMyTeamMyTeams
